export const SET_DADOS_COMPLEMENTARES_ESTADO_CIVIL = "SET_DADOS_COMPLEMENTARES_ESTADO_CIVIL";
export const LOADING_DADOS_COMPLEMENTARES_ESTADO_CIVIL = "LOADING_DADOS_COMPLEMENTARES_ESTADO_CIVIL";
export const ERROR_DADOS_COMPLEMENTARES_ESTADO_CIVIL = "ERROR_DADOS_COMPLEMENTARES_ESTADO_CIVIL";

export const SET_DADOS_COMPLEMENTARES_GENERO = "SET_DADOS_COMPLEMENTARES_GENERO";
export const LOADING_DADOS_COMPLEMENTARES_GENERO = "LOADING_DADOS_COMPLEMENTARES_GENERO";
export const ERROR_DADOS_COMPLEMENTARES_GENERO = "ERROR_DADOS_COMPLEMENTARES_GENERO";

export const SET_DADOS_COMPLEMENTARES_PAIS = "SET_DADOS_COMPLEMENTARES_PAIS";
export const LOADING_DADOS_COMPLEMENTARES_PAIS = "LOADING_DADOS_COMPLEMENTARES_PAIS";
export const ERROR_DADOS_COMPLEMENTARES_PAIS = "ERROR_DADOS_COMPLEMENTARES_PAIS";

export const CHANGE_DADOS_COMPLEMENTARES_VALUE_FORM = "ERROR_DADOS_COMPLEMENTARES";
export const HANDLE_CHANGE_DADOS_GENERO = "HANDLE_CHANGE_DADOS_GENERO";
export const HANDLE_CHANGE_DADOS_ESTADO_CIVIL = "HANDLE_CHANGE_DADOS_ESTADO_CIVIL";
export const HANDLE_CHANGE_DADOS_FLAG_PESSOA_AMERICANA = "HANDLE_CHANGE_DADOS_FLAG_PESSOA_AMERICANA";
export const HANDLE_CHANGE_DADOS_FLAG_DOMICIO_FISCAL = "HANDLE_CHANGE_DADOS_FLAG_DOMICIO_FISCAL";
export const HANDLE_CHANGE_TYPEAHEAD = "DADOS_COMPLEMETARES_HANDLE_CHANGE_TYPEAHEAD";
